import PropType from 'prop-types';
import React from 'react';
// source: https://github.com/DominicTobias/react-image-crop
import ReactCrop from 'react-image-crop';

import 'react-image-crop/dist/ReactCrop.css';

import {
  Modal,
  ModalActions,
  ModalContent,
  Pushbutton
} from '@stratumn/atomic';

export class CropDialog extends React.PureComponent {
  static propTypes = {
    onCancel: PropType.func.isRequired,
    onFinish: PropType.func.isRequired,
    imageSrc: PropType.string,
    actionLabel: PropType.string
  };

  static defaultProps = {
    actionLabel: null,
    imageSrc: null
  };

  state = {
    // Make sure image is cropped as a square.
    crop: { aspect: 1 },
    croppedImageUrl: null,
    croppedFile: null,
    cropped: false
  };

  fileName = 'cropped.png';

  onImageLoaded = image => {
    this.imageRef = image;
  };

  onChange = crop => {
    this.setState({ crop, cropped: crop.height > 0 && crop.width > 0 });
  };

  onComplete = crop => {
    if (this.imageRef && crop.width && crop.height) {
      const canvas = document.createElement('canvas');
      const scaleX = this.imageRef.naturalWidth / this.imageRef.width;
      const scaleY = this.imageRef.naturalHeight / this.imageRef.height;
      canvas.width = crop.width;
      canvas.height = crop.height;
      const ctx = canvas.getContext('2d');

      ctx.drawImage(
        this.imageRef,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        crop.width,
        crop.height
      );

      canvas.toBlob(blob => {
        blob.name = this.fileName;
        window.URL.revokeObjectURL(this.fileUrl);
        this.fileUrl = window.URL.createObjectURL(blob);
        const fileObj = new File([blob], this.fileName, {
          type: 'image/png'
        });
        this.setState({
          croppedFile: fileObj,
          croppedImageUrl: this.fileUrl
        });
      }, 'image/png');
    }
  };

  onCancel = () => {
    this.props.onCancel();
  };

  onFinish = () => {
    const { croppedFile, croppedImageUrl } = this.state;

    this.props.onFinish({ croppedImageUrl, croppedFile });
  };

  render() {
    const { imageSrc, actionLabel } = this.props;
    const { crop, cropped } = this.state;

    if (!imageSrc) return null;

    return (
      <Modal
        closeButtonLabel="Cancel"
        handleCollapse={this.onCancel}
        title="Crop your image."
      >
        <ModalContent centered>
          <ReactCrop
            crop={crop}
            onChange={this.onChange}
            onComplete={this.onComplete}
            onImageLoaded={this.onImageLoaded}
            src={imageSrc}
          />
        </ModalContent>
        <ModalActions>
          <Pushbutton data-testid="cancel-button" onClick={this.onCancel}>
            cancel
          </Pushbutton>
          <Pushbutton
            data-testid="crop-button"
            disabled={!cropped}
            onClick={this.onFinish}
            primary
          >
            {actionLabel}
          </Pushbutton>
        </ModalActions>
      </Modal>
    );
  }
}

export default CropDialog;
